export const RULERS_CSS = `
  /* ── Ruler bars ── */
  [data-string-rulers-top],
  [data-string-rulers-left] {
    position: absolute;
    z-index: 10001;
    display: block;
    cursor: crosshair;
    image-rendering: pixelated;
    transition: opacity 0.15s ease;
  }

  [data-string-rulers-top] {
    top: 0; left: 0;
    width: 100%; height: 20px;
    pointer-events: auto;
  }

  [data-string-rulers-left] {
    top: 0; left: 0;
    width: 20px; height: 100%;
    pointer-events: auto;
  }

  /* ── Corner mode toggle ── */
  [data-string-rulers-corner] {
    position: absolute;
    top: 0; left: 0;
    width: 20px; height: 20px;
    z-index: 10002;
    background: #E3E3E3;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
    cursor: pointer;
    transition: opacity 0.15s ease, background 0.15s ease;
  }

  [data-string-rulers-corner]:hover {
    background: #D8D8D8;
  }

  [data-string-rulers-corner][data-mode="center"] {
    background: #D4E8FF;
  }
  [data-string-rulers-corner][data-mode="center"]:hover {
    background: #C4DCFA;
  }

  [data-string-rulers-corner] > span {
    font: 10px "JetBrains Mono", monospace;
    color: #888888;
    white-space: nowrap;
    line-height: 1;
    pointer-events: none;
    user-select: none;
  }

  [data-string-rulers-corner][data-mode="center"] > span {
    color: #3B82F6;
  }

  /* ── Layout grid canvas ── */
  [data-string-rulers-grid] {
    position: absolute;
    top: 0; left: 0;
    z-index: 9998;
    pointer-events: none;
    image-rendering: pixelated;
    transition: opacity 0.15s ease;
  }

  /* ── Lines layer ── */
  [data-string-rulers-lines] {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 10000;
    overflow: hidden;
  }

  /* ── Guide lines ── */
  [data-string-rulers-line] {
    position: absolute;
    pointer-events: auto;
    opacity: var(--string-rulers-line-opacity, 1);
  }

  [data-string-rulers-line][data-axis="horizontal"] {
    border-top: 1px solid var(--string-rulers-line-color, rgba(0, 120, 255, 0.75));
    height: 0;
    cursor: ns-resize;
  }

  [data-string-rulers-line][data-axis="vertical"] {
    border-left: 1px solid var(--string-rulers-line-color, rgba(0, 120, 255, 0.75));
    width: 0;
    cursor: ew-resize;
  }

  /* ── Expanded hit area via ::before ──
     Adds 5px grab zone above/below horizontal lines,
     and 5px left/right of vertical lines — no change to visuals. */
  [data-string-rulers-line][data-axis="horizontal"]::before {
    content: '';
    display: block;
    position: absolute;
    left: 0; right: 0;
    top: -5px;
    height: 11px;
  }

  [data-string-rulers-line][data-axis="vertical"]::before {
    content: '';
    display: block;
    position: absolute;
    top: 0; bottom: 0;
    left: -5px;
    width: 11px;
  }

  [data-string-rulers-line]:hover {
    border-color: rgba(255, 60, 60, 0.85);
  }

  /* ── Coordinate label ── */
  [data-string-rulers-label] {
    position: absolute;
    top: 2px; left: 24px;
    font: 10px "JetBrains Mono", monospace;
    color: var(--string-rulers-line-color, rgba(0, 120, 255, 0.85));
    background: rgba(255,255,255,0.82);
    padding: 0 3px;
    border-radius: 3px;
    pointer-events: none;
    white-space: nowrap;
    line-height: 14px;
  }

  [data-string-rulers-line][data-axis="vertical"] [data-string-rulers-label] {
    top: 24px; left: 2px;
    writing-mode: vertical-lr;
  }

  /* ── Snap: ELEMENT (amber) ── */
  [data-string-rulers-line][data-snapping="element"][data-axis="horizontal"] {
    border-top-color: rgba(220, 120, 0, 0.9);
  }
  [data-string-rulers-line][data-snapping="element"][data-axis="vertical"] {
    border-left-color: rgba(220, 120, 0, 0.9);
  }
  [data-string-rulers-line][data-snapping="element"] [data-string-rulers-label] {
    color: rgba(180, 80, 0, 0.95);
  }

  /* ── Snap: GRID (green) ── */
  [data-string-rulers-line][data-snapping="grid"][data-axis="horizontal"] {
    border-top-color: rgba(0, 170, 80, 0.9);
  }
  [data-string-rulers-line][data-snapping="grid"][data-axis="vertical"] {
    border-left-color: rgba(0, 170, 80, 0.9);
  }
  [data-string-rulers-line][data-snapping="grid"] [data-string-rulers-label] {
    color: rgba(0, 130, 60, 0.95);
  }

  /* ── Snap: GUIDE GAP (cyan) ── */
  [data-string-rulers-line][data-snapping="guide"][data-axis="horizontal"] {
    border-top-color: rgba(0, 150, 170, 0.95);
  }
  [data-string-rulers-line][data-snapping="guide"][data-axis="vertical"] {
    border-left-color: rgba(0, 150, 170, 0.95);
  }
  [data-string-rulers-line][data-snapping="guide"] [data-string-rulers-label] {
    color: rgba(0, 120, 140, 0.98);
  }

  /* ── Snap: COLUMN (magenta) ── */
  [data-string-rulers-line][data-snapping="column"][data-axis="horizontal"] {
    border-top-color: rgba(200, 0, 100, 0.9);
  }
  [data-string-rulers-line][data-snapping="column"][data-axis="vertical"] {
    border-left-color: rgba(200, 0, 100, 0.9);
  }
  [data-string-rulers-line][data-snapping="column"] [data-string-rulers-label] {
    color: rgba(160, 0, 80, 0.95);
  }

  /* ── Guide-gap references ── */
  [data-string-rulers-line][data-string-rulers-guide-ref][data-axis="horizontal"] {
    border-top-color: rgba(0, 150, 170, 0.68);
  }
  [data-string-rulers-line][data-string-rulers-guide-ref][data-axis="vertical"] {
    border-left-color: rgba(0, 150, 170, 0.68);
  }

  [data-string-rulers-gap-indicator] {
    position: absolute;
    pointer-events: none;
    z-index: 10002;
  }

  [data-string-rulers-gap-indicator][data-axis="vertical"] {
    border-top: 1px dashed rgba(0, 150, 170, 0.95);
  }

  [data-string-rulers-gap-indicator][data-axis="horizontal"] {
    border-left: 1px dashed rgba(0, 150, 170, 0.95);
  }

  [data-string-rulers-gap-indicator-label] {
    position: absolute;
    font: 10px "JetBrains Mono", monospace;
    color: rgba(0, 120, 140, 0.98);
    background: rgba(255,255,255,0.92);
    border-radius: 3px;
    padding: 1px 4px;
    white-space: nowrap;
    line-height: 14px;
  }

  [data-string-rulers-gap-indicator][data-axis="vertical"] [data-string-rulers-gap-indicator-label] {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  [data-string-rulers-gap-indicator][data-axis="horizontal"] [data-string-rulers-gap-indicator-label] {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  /* ── Snap target element highlight ── */
  [data-string-rulers-snap-target] {
    outline: 1px dashed rgba(220, 120, 0, 0.55) !important;
    outline-offset: 0px;
  }

  /* ── Ghost (preview during drag from ruler) ── */
  [data-string-rulers-ghost] {
    position: absolute;
    pointer-events: none;
    opacity: calc(var(--string-rulers-line-opacity, 1) * 0.65);
  }

  [data-string-rulers-ghost][data-axis="horizontal"] {
    border-top: 1px dashed var(--string-rulers-line-color, rgba(0, 120, 255, 0.75));
    height: 0;
  }

  [data-string-rulers-ghost][data-axis="vertical"] {
    border-left: 1px dashed var(--string-rulers-line-color, rgba(0, 120, 255, 0.75));
    width: 0;
  }

  /* Ghost snap: ELEMENT (amber) */
  [data-string-rulers-ghost][data-snapping="element"][data-axis="horizontal"] {
    border-top-style: solid;
    border-top-color: rgba(220, 120, 0, 0.9);
    opacity: 0.85;
  }
  [data-string-rulers-ghost][data-snapping="element"][data-axis="vertical"] {
    border-left-style: solid;
    border-left-color: rgba(220, 120, 0, 0.9);
    opacity: 0.85;
  }

  /* Ghost snap: GRID (green) */
  [data-string-rulers-ghost][data-snapping="grid"][data-axis="horizontal"] {
    border-top-style: solid;
    border-top-color: rgba(0, 170, 80, 0.9);
    opacity: 0.85;
  }
  [data-string-rulers-ghost][data-snapping="grid"][data-axis="vertical"] {
    border-left-style: solid;
    border-left-color: rgba(0, 170, 80, 0.9);
    opacity: 0.85;
  }

  /* Ghost snap: COLUMN (magenta) */
  [data-string-rulers-ghost][data-snapping="column"][data-axis="horizontal"] {
    border-top-style: solid;
    border-top-color: rgba(200, 0, 100, 0.9);
    opacity: 0.85;
  }
  [data-string-rulers-ghost][data-snapping="column"][data-axis="vertical"] {
    border-left-style: solid;
    border-left-color: rgba(200, 0, 100, 0.9);
    opacity: 0.85;
  }

  /* Ghost snap: GUIDE GAP (cyan) */
  [data-string-rulers-ghost][data-snapping="guide"][data-axis="horizontal"] {
    border-top-style: solid;
    border-top-color: rgba(0, 150, 170, 0.95);
    opacity: 0.85;
  }
  [data-string-rulers-ghost][data-snapping="guide"][data-axis="vertical"] {
    border-left-style: solid;
    border-left-color: rgba(0, 150, 170, 0.95);
    opacity: 0.85;
  }

  /* ── Ghost coordinate label ── */
  [data-string-rulers-ghost-label] {
    position: absolute;
    font: 10px "JetBrains Mono", monospace;
    color: var(--string-rulers-line-color, rgba(0, 100, 220, 0.9));
    background: rgba(255, 255, 255, 0.9);
    padding: 1px 4px;
    border-radius: 3px;
    pointer-events: none;
    white-space: nowrap;
    line-height: 14px;
  }

  [data-string-rulers-ghost][data-snapping="element"] [data-string-rulers-ghost-label] {
    color: rgba(180, 80, 0, 0.95);
  }
  [data-string-rulers-ghost][data-snapping="grid"] [data-string-rulers-ghost-label] {
    color: rgba(0, 130, 60, 0.95);
  }
  [data-string-rulers-ghost][data-snapping="guide"] [data-string-rulers-ghost-label] {
    color: rgba(0, 120, 140, 0.98);
  }
  [data-string-rulers-ghost][data-snapping="column"] [data-string-rulers-ghost-label] {
    color: rgba(160, 0, 80, 0.95);
  }

  [data-axis="horizontal"] [data-string-rulers-ghost-label] {
    top: 3px; left: 24px;
  }
  [data-axis="vertical"] [data-string-rulers-ghost-label] {
    left: 3px; top: 24px;
  }

  /* ── Fixed guide lines (center cross, etc.) ── */
  [data-string-rulers-fixed-line] {
    position: absolute;
    pointer-events: none;
  }

  [data-string-rulers-fixed-line][data-axis="horizontal"] {
    border-top: 1px dashed rgba(100, 100, 100, 0.35);
    height: 0;
  }

  [data-string-rulers-fixed-line][data-axis="vertical"] {
    border-left: 1px dashed rgba(100, 100, 100, 0.35);
    width: 0;
  }

  /* ── Hidden state ── */
  [data-string-rulers-hidden] [data-string-rulers-grid],
  [data-string-rulers-hidden] [data-string-rulers-top],
  [data-string-rulers-hidden] [data-string-rulers-left],
  [data-string-rulers-hidden] [data-string-rulers-corner],
  [data-string-rulers-hidden] [data-string-rulers-lines],
  [data-string-rulers-hidden] [data-string-rulers-line],
  [data-string-rulers-hidden] [data-string-rulers-fixed-line],
  [data-string-rulers-hidden] [data-string-rulers-gap-indicator],
  [data-string-rulers-hidden] [data-string-rulers-ghost] {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }
`;
